import { render, staticRenderFns } from "./userdrop.vue?vue&type=template&id=16a1034a&scoped=true"
import script from "./userdrop.vue?vue&type=script&lang=js"
export * from "./userdrop.vue?vue&type=script&lang=js"
import style0 from "./userdrop.vue?vue&type=style&index=0&id=16a1034a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1034a",
  null
  
)

export default component.exports